import * as React from "react";
import { Query, QueryCondition, AuditTrailEntity } from "../../misc/api/apiTypes";
import { getQueryFilters } from "../../misc/components/queryTable/ReducerUtilities";
import MultiSelectModal from "../../misc/components/queryTable/MultiSelectModal";
import uniqBy from "lodash-es/uniqBy";
import { GetFilterValues } from "../../misc/components/queryTable/FilterValuesSelector";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export interface ActionFilterProps {
    analysisSetOldId: number;
    auditQuery: Query<AuditTrailEntity>;
    isActionFilterVisible: boolean;
    onChange: (auditQuery: Query<AuditTrailEntity>) => Promise<void>;
    onClose: () => void;
    filterableEntityTypes: string[];
}

export interface ActionFilterState {
    actionTypesQuery: Query<AuditTrailEntity>;
}

export const ActionFilter = (props: ActionFilterProps) => {
    const ActionNameQueryMember = "Event.ActionName";
    const TypeNameQueryMember = "TypeName";

    const [actionTypesQuery, setActionTypesQuery] = React.useState<Query<AuditTrailEntity>>({
        Members: [ActionNameQueryMember],
        Filters: [{ Member: TypeNameQueryMember, Values: props.filterableEntityTypes }]
    })

    const [data, setData] = React.useState([]);

    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getActionTypes = async () => {
            await fetchActionTypes(actionTypesQuery);
        }

        getActionTypes();
    }, [actionTypesQuery.Filters]);

    const onActionChange = async e => {
        const filters = getQueryFilters(
            props.auditQuery,
            ActionNameQueryMember,
            QueryCondition.Equal,
            e
        );

        const eventsQuery: Query<AuditTrailEntity> = {
            ...props.auditQuery,
            Filters: filters
        };

        await props.onChange(eventsQuery);
    };

    const onCloseFilter = () => {
        onActionChange([]);
        props.onClose();
    }

    const fetchActionTypes = async (actionTypeQuery: Query<AuditTrailEntity>) => {
        const filters = getQueryFilters(
            actionTypesQuery,
            "RecordId",
            QueryCondition.Equal,
            [props.analysisSetOldId, "," + props.analysisSetOldId + "]", "[" + props.analysisSetOldId + ","]
        )

        actionTypeQuery = {
            ...actionTypesQuery,
            Filters: filters,
        };

        const actionTypesQueryResult = await legacyClient.getAnalysisSetAuditEntities(actionTypeQuery);
        setData(actionTypesQueryResult.Data);
    }

    return (
        <ErrorBoundary>
            <MultiSelectModal
                header="Action Filter"
                show={props.isActionFilterVisible}
                options={
                    data
                        ? uniqBy(data, x => x.ActionName)
                        : []
                }
                valueKey="ActionName"
                labelKey="ActionName"
                values={GetFilterValues(
                    "Event.ActionName",
                    QueryCondition.Equal,
                    props.auditQuery
                )}
                onChange={e => onActionChange(e.map(v => v.ActionName))}
                onApply={() => props.onClose()}
                onClose={onCloseFilter}
            />
        </ErrorBoundary>
    );
}
